import ReactSelect from "react-select";
import { NoOptionsMessageIcon } from "../../../../assets/icons/svgicons";
import ErrorText from "../ErrorText/ErrorText";
import styles from "./Select.module.scss";

const Select = ({
  options,
  className,
  label,
  variant,
  formik,
  formatOptionLabel,
  placeholder,
  name,
  isSearchable,
  reactSelectClassName,
  menuIsOpen,
  ...rest
}) => {
  const formatOption = (option) => {
    if (!option.icon) {
      return <h5>{option.label}</h5>;
    } else {
      return (
        <div className="icon_option"> 
          <img src={option.icon} alt="option-icon" />
          <h5>{option.label}</h5>
        </div>
      );
    }
  };
  return (
    <div
      className={`${styles.select} ${className || ""}`}
      data-variant={variant}
    >
      {label && <label>{label}</label>}
      <ReactSelect
        {...rest}
        className={`react-select ${reactSelectClassName}`}
        placeholder={placeholder}
        isSearchable={isSearchable}
        noOptionsMessage={() => {
          return (
            <div className="no_records">
              {/* <span>
                <NoOptionsMessageIcon />
              </span> */}
              <h5>
                {/* Nothing to <br /> see here! */}
                No record found
              </h5>
            </div>
          );
        }}
        options={options}
        classNamePrefix="select"
        menuIsOpen={menuIsOpen}
        formatOptionLabel={formatOptionLabel || formatOption}
      />
      {formik?.touched[name] && formik?.errors[name] && (
        <ErrorText>{formik?.errors[name]}</ErrorText>
      )}
    </div>
  );
};

export default Select;
